module.exports = __webpack_public_path__ + "img/CF_danger.aa77decc.svg";